import { Suspense } from 'react'
import { Outlet, useMatch } from 'react-router-dom'
import { motion } from 'framer-motion'
import { fadeIn, storeTransition } from '@/store/ui/motion'
import { StoreRouteFallback } from '@/store/components/StorePageLoader'
import { StoreFooter } from './StoreFooter'
import { StoreHeader } from './StoreHeader'
import { StoreMobileHeader } from './StoreMobileHeader'
import { StoreBottomNav } from './StoreBottomNav'
import { StoreTabNavSync } from './StoreTabNavSync'
import { WhatsAppButton } from './WhatsAppButton'
import { PurchaseActivityToast } from './PurchaseActivityToast'
import { useStoreGate } from '@/contexts/StoreGateContext'

export function StoreLayout() {
  const { settings } = useStoreGate()
  const isProductDetail = Boolean(useMatch('/shop/:id'))
  const isCheckout = Boolean(useMatch('/checkout'))
  const isCart = Boolean(useMatch('/cart'))
  const showBottomNav = !isProductDetail && !isCheckout

  return (
    <div className="flex min-h-screen w-full max-w-[100vw] flex-col overflow-x-clip">
      <StoreTabNavSync />
      <StoreMobileHeader />
      <StoreHeader />
      <motion.main
        initial="hidden"
        animate="visible"
        variants={fadeIn}
        transition={storeTransition}
        className="store-main flex-1"
      >
        <Suspense fallback={<StoreRouteFallback />}>
          <Outlet context={{ settings }} />
        </Suspense>
      </motion.main>
      <StoreFooter
        instagram={settings?.instagram}
        email={settings?.email}
        phone={settings?.phone}
        whatsapp={settings?.whatsapp}
      />
      {isProductDetail && (
        <div aria-hidden className="product-mobile-bar-spacer lg:hidden" />
      )}
      {showBottomNav && (
        <>
          <StoreBottomNav />
          <div aria-hidden className="store-bottom-nav-spacer lg:hidden" />
        </>
      )}
      {!isCart && !isCheckout && (
        <>
          <PurchaseActivityToast aboveBottomNav={showBottomNav} />
          <WhatsAppButton
            phone={settings?.whatsapp}
            aboveBottomNav={showBottomNav}
          />
        </>
      )}
    </div>
  )
}
